/*
    const partKindClassMap = {
        text: 'mirrorsharp-tip-part-text',
        class: 'cm-type',
        struct: 'cm-type'
    };
*/
export function renderPart(parent, part) {
  const span = document.createElement('span');
  span.className = 'cm-' + part.kind;
  span.textContent = part.text;
  parent.appendChild(span);
}
export function renderParts(parent, parts) {
  for (const part of parts) {
    renderPart(parent, part);
  }
}